import { EXCHANGE_LOGOS } from "./logo";

export const getExchangeLogo = (exchangeId: string): string => {
  // Force value for vitest test
  if (process?.env?.VITEST_WORKER_ID) return exchangeId.toLowerCase().replace(".", "") + ".svg";
  if (!exchangeId) return "";
  return EXCHANGE_LOGOS[exchangeId] || "";
};
